// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@eisinc/Overrides/Widgets/Brand/BrandList";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

listStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

listStyles.brandLetter = {
    variant: "h2",
    css: css`
        text-transform: uppercase;
    `,
};

listStyles.brandItemsWrapper = {
    css: css`
        margin: 0;
        max-width: 100%;
    `,
};

listStyles.brandItem = {
    width: [12, 6, 6, 3, 3],
};

listStyles.brandLink = {
    color: "text.main",
    typographyProps: {
        size: fontConfig.regular.size,
        lineHeight: fontConfig.singleLineRegular.lineHeight,
        css: css`
            margin: 0;
        `,
    },
};

listStyles.brandSections = {
    css: css`
        &:not(:last-child) {
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 32px;
        }
    `,
};
